import PropTypes from 'prop-types'

const CoachLogo = ({ memberType, certificationLevel, size }) => {
  const getPgaCrest = {
    CERTIFIED: '/images/pga-member-logo.svg',
    SPECIALIZED: '/images/pga-member-logo.svg',
    MASTER: '/images/pga-master-logo.svg',
    MEMBER: '/images/pga-member-logo.svg',
  }

  if (memberType === 'AP' || memberType === 'ST' || memberType === 'QE' || !memberType) return null
  return certificationLevel ? (
    <img
      style={{ height: size || '78px', width: size || '78px' }}
      src={getPgaCrest[certificationLevel]}
      alt="PGA Crest"
    />
  ) : null
}

CoachLogo.propTypes = {
  certificationLevel: PropTypes.string,
  memberType: PropTypes.string,
  size: PropTypes.string,
}

export default CoachLogo
